import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useQuery, ApolloProvider } from 'react-apollo';
import ReactSVG from 'react-svg';
import marker from 'map_marker.svg';
import { client } from '../client';
import { LISTING_SEARCH_QUERY } from '../../constants/queries';
import useOutsideClick from '../../hooks/useOutsideClick';
import BusinessDropdownItem from './BusinessDropdownItem';
import LoadingDropdownItem from '../Loading/LoadingDropdownItem';

const tokenElement = document.querySelector('[name=csrf-token]');

function BusinessSearch() {
  const wrapperRef = useRef(null);
  const businessSearchRef = useRef(null);
  const businessSearchInputRef = useRef(null);

  const [tempBizSearch, setTempBizSearch] = useState('');
  const [bizSearch, setBizSearch] = useState('');
  const [focused, setFocused] = useState(false);

  const { data, loading, refetch } = useQuery(LISTING_SEARCH_QUERY, {
    skip: !bizSearch,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (bizSearch) {
      refetch({ title_cont: bizSearch });
    }
  }, [bizSearch, refetch]);

  useOutsideClick(wrapperRef, true, () => {
    setTempBizSearch('');
    setFocused(false);
  });

  const handleSelect = async listing => {
    setTempBizSearch('');
    setBizSearch(listing.title);

    const res = await axios.get(`/claim-listing?listing_id=${listing.id}`, {
      headers: {
        'X-CSRF-Token': tokenElement ? tokenElement.content : '',
      },
    });

    document.querySelector('#claim-listing-modal-wrapper').innerHTML = res.data;
    document
      .querySelector('#claim_listing_modal_container')
      .classList.remove('hidden');
    document.querySelector('body').style.overflow = 'hidden';

    const { clearAllBodyScrollLocks } = window.bodyScrollLock;

    document
      .querySelector('#claim-listing-close')
      .addEventListener('click', () => {
        document
          .querySelector('#claim_listing_modal_container')
          .classList.add('hidden');

        window.history.pushState(null, null, `${window.location.pathname}`);
        localStorage.removeItem('claim_listing');

        clearAllBodyScrollLocks();
        document.querySelector('body').style.overflow = '';
      });

    setTimeout(() => {
      const phoneInput = document.querySelector('.tel[type="tel"]');

      function setMaxLength(e) {
        const { value } = e.target;
        if (value.includes('(')) {
          phoneInput.setAttribute('maxlength', 14);
        } else if (value.includes('-')) {
          phoneInput.setAttribute('maxlength', 12);
        } else {
          phoneInput.setAttribute('maxlength', 10);
        }
      }

      phoneInput.addEventListener('keydown', setMaxLength);
      phoneInput.addEventListener('change', setMaxLength);
    }, 0);

    document.querySelector(
      '.modal-title'
    ).textContent = `Claim ${listing.title} as Business Owner`;
  };

  const showListings = data && data.search && data.search.listings;

  const dropdownEmpty = !data || !focused;

  return (
    <div ref={wrapperRef}>
      <form
        ref={businessSearchRef}
        className="communities-search-container business-search-wrapper"
      >
        <section className="input-wrapper">
          <div className="input">
            <input
              ref={businessSearchInputRef}
              aria-label="Search for your Business"
              value={tempBizSearch || bizSearch}
              placeholder="Search for your Business"
              className="business-search-input"
              onChange={e => setBizSearch(e.target.value)}
              onFocus={() => setFocused(true)}
            />
          </div>
        </section>
        <button
          type="button"
          aria-label="Search"
          className="btn btn--blue-grad"
          onClick={() => {
            window.scroll(
              0,
              businessSearchRef.current.getBoundingClientRect().top
            );
            setFocused(true);
            businessSearchInputRef.current.focus();
          }}
        >
          Search
        </button>
      </form>
      <div className="business-dropdown-wrapper">
        {loading && !showListings && <LoadingDropdownItem />}
        {!dropdownEmpty &&
          data.search.listings.slice(0, 8).map(listing => (
            <BusinessDropdownItem
              key={listing.id}
              onBlur={() => setTempBizSearch('')}
              onMouseLeave={() => setTempBizSearch('')}
              onFocus={() => setTempBizSearch(listing.title)}
              onMouseOver={() => setTempBizSearch(listing.title)}
              onClick={() => handleSelect(listing)}
            >
              <ReactSVG src={marker} />
              <p>
                <span>{listing.title}</span> • {listing.address}
              </p>
            </BusinessDropdownItem>
          ))}
        <a
          href={window.Routes.new_listing_path()}
          aria-label=""
          className="business-dropdown-item no-results"
        >
          <p>
            Don’t see your business? <span>Create your listing here.</span>
          </p>
        </a>
      </div>
    </div>
  );
}

export default function BusinessSearchWrapper() {
  return (
    <ApolloProvider client={client}>
      <BusinessSearch />
    </ApolloProvider>
  );
}
